import styled from 'styled-components';

export const Container = styled.div`
    padding-top: 1rem;

    > header {
        display: flex;
        margin-top: 0.5rem;

        > p {
            text-align: center;
        }
    }

    > footer {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin-top: 1rem;
    }
`;

export const StyledPaper = styled.div`
    width: 25%;
    > header {
        padding-top: 1rem;
        padding-left: 1rem;
        > h1 {
            font-size: 1rem;
            font-weight: 700;
            text-align: left;
        }
    }
    > main {
        padding: 1rem;
    }
`;
